import { render } from "./OfferItem.vue?vue&type=template&id=638aa3b0&scoped=true"
import script from "./OfferItem.vue?vue&type=script&lang=js"
export * from "./OfferItem.vue?vue&type=script&lang=js"

import "./OfferItem.vue?vue&type=style&index=0&id=638aa3b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-638aa3b0"

export default script